import React, { Component } from 'react';
import ReactIScroll from 'react-iscroll';
import iScroll from 'iscroll';
import _ from 'lodash';
import BRSpan from '../../General/BRSpan';

class DonorListSeattle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      renderedColumns: null,
      hasTributes: false
    }
    this.iScroller = null;
    this._contentRef = null;
  } 

  componentDidMount() {
    this.renderDonors();
    this.intervalCheckSwipeAnimation();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps !== this.props) {
      this.renderDonors();
    }
  }

  intervalCheckSwipeAnimation = () => {
    if (!this._contentRef) {
      setTimeout(() => {
        this.intervalCheckSwipeAnimation();
      }, 100);
    } else {
      this.checkSwipeAnimation();
    }
  }

  checkSwipeAnimation = () => {
    let scrollWrapperHeight = .28 * this.props.regionWidth;
    let contentHeight = this._contentRef.getBoundingClientRect().height;
    this.props.handleSwipeAnimation(scrollWrapperHeight, contentHeight);
  }

  renderDonors = () => {
    let orderedDonors = _.orderBy(this.props.items, [item => item.sorting_name.toLowerCase()], ['asc']); 
    let columnOne = [];
    let columnTwo = [];
    let hasTributes = false;
    let renderedColumns = "";

    for (let i = 0; i < orderedDonors.length; i++) {
      if (orderedDonors[i].contents.arrays_values && orderedDonors[i].contents.arrays_values.acknowledgment_text_options) {
        hasTributes = true;
      }
      if (i === 0 || i % 2 === 0) {
        columnOne.push(orderedDonors[i]);
      } else {
        columnTwo.push(orderedDonors[i]);
      }
    }

    if (hasTributes) {
      let renderedColumnDonors = orderedDonors.map((donor, i) => {
        return (
          <div key={i} style={{ width:"100%", textAlign:"left", minHeight:0.013 * this.props.regionWidth, display:"block", paddingTop: .0052 * this.props.regionWidth }}>
            <div className="noselect" style={{ maxWidth:"85%", fontSize:0.009 * this.props.regionWidth }}>{donor.name}</div>
            <div className="noselect" style={{ marginLeft:"5%", maxWidth:"80%", fontSize:0.0075 * this.props.regionWidth }}>
              { this.getTributes(donor) }
            </div>
          </div>
        );
      });

      renderedColumns = (
        <div style={{ position:"relative", display:"flex" }} ref={el => this._contentRef = el}>
          <div style={{ width:0.168 * this.props.regionWidth }}>
            {renderedColumnDonors}
          </div>
        </div>
      );
    } else {
      let renderedColumnOneDonors = columnOne.map((donor, i) => {
        let marginBottom = donor.contents.arrays_values && donor.contents.arrays_values.acknowledgment_text_options ? .002 * this.props.regionWidth : 0;
        return (
          <div key={i} style={{ width:"100%", textAlign:"left", minHeight:0.013 * this.props.regionWidth, display:"block", paddingTop: .0052 * this.props.regionWidth }}>
            <div className="noselect" style={{ maxWidth:"85%", fontSize:0.009 * this.props.regionWidth, marginBottom: marginBottom }}>{donor.name}</div>
            {/* <div style={{ marginLeft:"5%", maxWidth:"80%", fontSize:0.0075 * this.props.regionWidth }}>
              { this.getTributes(donor) }
            </div> */}
          </div>
        );
      });
  
      let renderedColumnTwoDonors = columnTwo.map((donor, i) => {
        let marginBottom = donor.contents.arrays_values && donor.contents.arrays_values.acknowledgment_text_options ? .002 * this.props.regionWidth : 0;
        return (
          <div key={i} style={{ width:"100%", textAlign:"left", minHeight:0.013 * this.props.regionWidth, display:"block", paddingTop: .0052 * this.props.regionWidth }}>
            <div className="noselect" style={{ maxWidth:"85%", fontSize:0.009 * this.props.regionWidth, marginBottom: marginBottom }}>{donor.name}</div>
            {/* <div style={{ marginLeft:"5%", maxWidth:"80%", fontSize:0.0075 * this.props.regionWidth }}>
              { this.getTributes(donor) }
            </div> */}
          </div>
        );
      });
  
      renderedColumns = (
        <div style={{ position:"relative", display:"flex" }} ref={el => this._contentRef = el}>
          <div style={{ width:0.168 * this.props.regionWidth, float:"left" }}>
            {renderedColumnOneDonors}
          </div>
          <div style={{ width:0.168 * this.props.regionWidth }}>
            {renderedColumnTwoDonors}
          </div>
        </div>
      );
    }

    this.setState({
      hasTributes: hasTributes,
      renderedColumns: renderedColumns
    });
  }

  getTributes = (donor) => {
    let renderedTributes = []
    if (donor.contents.arrays_values && donor.contents.arrays_values.acknowledgment_text_options) {
      renderedTributes = donor.contents.arrays_values.acknowledgment_text_options.map((opt, i) => {
        return (
          <div key={i}>
            <div className="noselect" style={{ paddingTop: this.props.regionWidth * .00175, paddingBottom: this.props.regionWidth * .0035  }}>{`${opt.acknowledgment_text_options.val.title} ${opt.donor_name.val}`}</div>
          </div>
        );
      });
    }

    return renderedTributes;
  }

  render() {
    let justified = this.state.hasTributes ? "center" : "";
    return (
      <div style={{ width:"100%", height:"100%", display:"table" }}>
        <div style={{ display:"table-cell", verticalAlign:"middle", marginLeft:"auto", marginRight:"auto", position:"relative" }}>
          <div style={{ position:"relative", width:"85%", minHeight:0.024 * this.props.regionWidth, maxHeight: .090 * this.props.regionWidth, textAlign:"center", overflow:"hidden", marginLeft:"auto", marginRight:"auto" }}>
            <div className="noselect" style={{ fontSize:0.020 * this.props.regionWidth }}><BRSpan className="noselect" preWrap str={this.props.parent.name.toUpperCase()}/></div>
          </div>
          <div style={{ position:"relative", width:"85%", minHeight: .026 * this.props.regionWidth, maxHeight:0.084 * this.props.regionWidth, textAlign:"center", display:"flex", alignItems:"center", justifyContent:"center", overflow:"hidden", marginLeft:"auto", marginRight:"auto", marginTop: .0086 * this.props.regionWidth }}>
            <div className="noselect" style={{ fontSize:0.011 * this.props.regionWidth, fontStyle:"italic" }}><BRSpan className="noselect" preWrap str={this.props.parent.description}/></div>
          </div>
          <div style={{ width:.3038 * this.props.regionWidth, height: 0.28 * this.props.regionWidth, position:"relative", left:.07638 * this.props.regionWidth, touchAction:"none", marginTop: .0086 * this.props.regionWidth }}>
            <ReactIScroll ref={el => this.iScroller = el} iScroll={iScroll}
              options={{
                mouseWheel: true,
                scrollbars: false,
                scrollX: false,
                scrollY: true,
                probeType: 2,
                bounce: false,
                momentum: true,
                deceleration: 0.015,
                useTransition: true,
                disableTouch: false,
                disablePointer: false,
                disableMouse: false,
              }}
            >
              <div style={{ position:"relative", display:"flex", justifyContent: justified }}>
                {this.state.renderedColumns}
              </div>
            </ReactIScroll>
          </div>
        </div>
      </div>
    );
  }
}

export default DonorListSeattle;


// WEBPACK FOOTER //
// ./src/Components/Theme/Seattle/DonorListSeattle.jsx